var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import classNames from 'classnames';
import { IDENTIFIER_DATETIME_TABS } from 'src/ui/components/Input/DateTimeInput/constants';
import styles from './dateTabs.module.scss';
import { getPropsByKeyPath } from 'src/shared/helpers/objHelpers';
export var DateTabs = function (props) {
    var _a;
    var i18n = props.i18n, dateTabs = props.dateTabs, currentTab = props.currentTab, onTabChange = props.onTabChange;
    var _b = useState({
        visible: false,
    }), currentFocus = _b[0], setCurrentFocus = _b[1];
    var listRef = useRef(null);
    var handleHoverItem = function (e) {
        var _a = e.target.getBoundingClientRect(), y = _a.y, height = _a.height;
        var top = listRef.current.getBoundingClientRect().top;
        setCurrentFocus({ top: y - top, visible: true, height: height });
    };
    var handleHoverLeave = function () {
        setCurrentFocus(function (prev) { return ({ visible: false }); });
    };
    var handleItemClick = function (e, tabType) {
        e.stopPropagation();
        onTabChange(tabType);
    };
    var focusSelectorElementClass = classNames(styles.itemFocus, (_a = {},
        _a[styles.itemFocusVisible] = currentFocus.visible,
        _a));
    return (_jsxs("ul", __assign({ "data-test": IDENTIFIER_DATETIME_TABS, ref: listRef, className: styles.dateTabsWrapper, onMouseLeave: handleHoverLeave }, { children: [_jsx("div", { className: focusSelectorElementClass, style: currentFocus.top !== undefined
                    ? {
                        top: currentFocus.top,
                        height: currentFocus.height,
                    }
                    : null }), dateTabs.map(function (tab) {
                var _a;
                var tabLabel = getPropsByKeyPath(i18n === null || i18n === void 0 ? void 0 : i18n.components, "dateTimeRangeSelectInput.customLabels.".concat(tab.labelKey)) || tab.labelKey;
                return (_jsx("li", __assign({ className: classNames(styles.dateTabsListItem, (_a = {},
                        _a[styles.dateTabsListItemActive] = currentTab && currentTab.labelKey === tab.labelKey,
                        _a)), onMouseMove: handleHoverItem, onClick: function (e) { return handleItemClick(e, tab); } }, { children: tabLabel }), tab.type));
            })] })));
};
